import { action } from 'mobx';
import stores from '../../../models/Stores';

export class Error401VM {
  props: any;
  constructor(props: undefined) {
    this.props = props;
  }

  @action.bound onSubmit(e) {
    e.preventDefault();
    // set store vairables to false --> appVM redirects to login page
    stores.AppStore.userProfileStore.authError = false;
    stores.AppStore.userProfileStore.userAvailable = false;
  }
}
